export default {
  header: "تم تنصيب خدمات الطلب بنجاح",
  paragraph1: "1 - {{brandName}} الان على تطبيق الجوال",
  paragraph2:
    "2 - {{brandName}} غير متاح الان لتفعيله و استقبال طلبات جديده اتصل بالكاشير فى الفرع ",
  paragraph3:
    "3 - {{brandName}} تسطيع اظهار اداء الطلبات و سجل الطلبات من لوحه التحكم",
  btnLabel: "الذهاب الى سجل الطلبات",
};
